@if(currentFollowup.id > 0) {
    <div class="followup-cell-complete">
        <div>
            @switch(currentFollowup.priority) {
                    @case(1) {
                        <mat-icon class="low-green">arrow_downward</mat-icon>
                    }
                    @case(2) {
                        <mat-icon class="med-yellow">arrow_upward</mat-icon>
                    }
                    @case(3) {
                        <mat-icon class="high-red">arrow_upward</mat-icon>
                    }
            }

            <div class="follow-up-date">
                {{ currentFollowup.followupDate | date : 'MM/dd/yy hh:mm a' }}
            </div>
        </div>

        <div>
            @if(currentFollowup.initialCanEdit) {
            <mat-icon class="markAsComplete" matTooltip="Mark As Complete"
                (click)="openMarkAsCompleteDialog()">check_circle</mat-icon>
            }
        </div>
    </div>
}

@if(currentFollowup.id === 0 || (currentFollowup.id | isValueEmpty)) {
    <div class="followup-cell-incomplete">
        <div>
            @if(currentFollowup.initialCanEdit) {
                <mat-icon class="addFollowUpButton" matTooltip="Add Follow Up"
                    #menuTrigger="matMenuTrigger" (click)="initLookups()"
                    [matMenuTriggerFor]="actionMenu">add_circle_outline</mat-icon>
            }
        </div>
    </div>

    <mat-menu #actionMenu="matMenu">
        <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">

            <form [formGroup]="resourcesForm">

                <div class="follow-up">
                    <div class="priority-follow-up">
                        <mat-form-field class="app-form-field app-high-form-field app-form-field-with-border priority">
                            <mat-icon [ngClass]="priority?.class" class="prefix">{{priority?.icon}}</mat-icon>
                            <div class="prefix-title">{{priority?.value}}</div>
                            <mat-select panelClass="recruiter-panel-class" disableOptionCentering="true"
                                class="priority-select" formControlName="priorityList"
                                (selectionChange)="selectionPriorityChange($event.value)">
                                @for(priority of priorityList; track priority) {
                                    <mat-option class="select-option"
                                        [value]="priority">
                                        <mat-icon [ngClass]="priority?.class" class="inner-prefix">{{priority?.icon}}
                                        </mat-icon>
                                        {{ priority?.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="calendar-wrap">
                        <mat-form-field [floatLabel]="'never'"
                            class="app-form-field app-high-form-field app-full-width-form-field app-form-field-with-border whitelisted calendar">
                            <input matInput placeholder="MM/DD/YYYY" [mask]="shortDateMask" [leadZeroDateTime]="true"
                                [dropSpecialCharacters]="false" formControlName="date" />
                            <mat-icon (click)="toggleCalendar($event)" class="suffix whitelisted">event</mat-icon>
                        </mat-form-field>
                    </div>

                    <div class="time-wrap">
                        <mat-form-field
                            class="app-form-field app-high-form-field app-full-width-form-field app-form-field-with-border timer">
                            <mat-select panelClass="recruiter-panel-class" disableOptionCentering="true" class="time"
                                formControlName="time">
                                @for(hour of hours; track hour) {
                                    <mat-option [value]="hour">
                                        {{ hour.followupTime }}
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-icon class="suffix">schedule</mat-icon>
                        </mat-form-field>
                    </div>
                </div>
                <div>
                    @if(resourcesForm?.controls?.date?.invalid && resourcesForm?.controls?.date?.dirty) {
                        <mat-error>This date is invalid</mat-error>
                    }
                </div>
                <div class="followup-reason">
                    <mat-form-field class="app-form-field app-form-field-with-border" floatLabel="never">
                        <input matInput #reason formControlName="followupReason" maxlength="50"
                            placeholder="Reason (optional)">
                        <mat-hint align="end">{{ reason?.value?.length }} / 50</mat-hint>
                        @if(hasError('followupReason', 'maxlength')) {
                            <mat-error>Max 50 characters</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="followup-actions">
                    <button mat-raised-button
                        class="excel-export app-grid-header-right-button app-grid-header-dark-button" color="primary"
                        (click)="saveFollowUp()">
                        <span>
                            ADD FOLLOW UP
                        </span>
                    </button>
                </div>

            </form>

            @if(showCalendar) {
                <div class="calendar-wrapper">
                    <div class="text-hint-calendar">
                        Follow-Ups Scheduled
                        <span class="chips-calendar low-data">0-20</span>
                        <span class="chips-calendar med-data">21-40</span>
                        <span class="chips-calendar high-data">41+</span>
                    </div>
                    <calendar (selectedDate)="updateDate($event)" [followupDates]="followupsByDay"
                        [selectedDates]="selectedDates" (dateChanged)="selectedDateChanged($event)">
                    </calendar>
                </div>
            }
        </div>
    </mat-menu>
}